import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const React = require("react");
import { List } from "immutable";
import { features } from "../../../features";
import { classNamesConfig } from "../../../features/classnames";
import { getLoader } from "../../../features/loader";
import { EventCard } from "../../Events/EventCard";
export const ActivitySelectionBlockLayout = (props)=>{
    const { field_title, field_description, events } = props;
    const config = features().events;
    if (config == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const className = classNamesConfig().activities_selection_block;
    const loader = getLoader();
    const loading = events.kind == "loading";
    const cards = events.kind == "loaded" && List(events.value).sortBy((e)=>e.Start ?? 0).map((e)=>/*#__PURE__*/ _jsx(EventCard, {
            event: toCardEvent(e),
            linkUrl: `${config.prefix}/${e.Id}`,
            headingLevel: "h3",
            variant: "stacked"
        }, `event__${e.Id}`));
    return /*#__PURE__*/ _jsxs("section", {
        className: `block block--activity-selection ${className.block}`,
        children: [
            /*#__PURE__*/ _jsxs("header", {
                className: `block__header ${className.inner}`,
                children: [
                    field_title && /*#__PURE__*/ _jsx("h2", {
                        className: "block__title title--l container--xs",
                        children: field_title
                    }),
                    field_description && /*#__PURE__*/ _jsx("div", {
                        className: "block__intro",
                        dangerouslySetInnerHTML: {
                            __html: field_description
                        }
                    })
                ]
            }),
            loading && loader(),
            cards && cards.size > 0 && /*#__PURE__*/ _jsx("ul", {
                className: "a-content__list a-content__list--grid",
                children: cards.toArray()
            })
        ]
    }, `activities_selection_block_${props.id}`);
};
// The details API nests children via ChildEvents; the card's meta helpers traverse Events
const toCardChild = (details)=>{
    var _details_ChildEvents;
    return {
        Id: details.Id,
        Kind: details.Kind,
        Start: details.Start,
        End: details.End,
        Status: details.Status,
        Locations: details.Locations,
        Events: (_details_ChildEvents = details.ChildEvents) === null || _details_ChildEvents === void 0 ? void 0 : _details_ChildEvents.map(toCardChild)
    };
};
const toCardEvent = (details)=>{
    var _details_ChildEvents;
    return {
        Id: details.Id,
        Title: details.Title,
        Subtitle: details.Subtitle,
        TeaserText: details.TeaserText,
        Image: details.Image,
        Start: details.Start,
        End: details.End,
        Status: details.Status,
        Tags: details.Tags,
        Locations: details.Locations,
        ChildEvents: (_details_ChildEvents = details.ChildEvents) === null || _details_ChildEvents === void 0 ? void 0 : _details_ChildEvents.map(toCardChild)
    };
};
